import styles from './styles.module.css';

type PanelTitleProps = {
  children: React.ReactNode;
};

const PanelTitle: React.FunctionComponent<PanelTitleProps> = (props: PanelTitleProps) => {
  return <p className={styles.title}>{props.children}</p>;
};

export default PanelTitle;
